import {Component, OnInit, Input, Output, EventEmitter, Inject} from '@angular/core';
import { ColunasListPaginator, PaginatorHelper } from 'src/app/core/shared-components/list-paginator';
import {Observable, of} from 'rxjs';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DatePipe} from '@angular/common';


@Component({
  selector: 'rot-dialog-popup-rodizio-veiculo',
  templateUrl: './dialog-popup-rodizio-veiculo.component.html',
  styleUrls: ['./dialog-popup-rodizio-veiculo.component.scss']
})
export class DialogPopupRodizioVeiculoComponent implements OnInit {

  datePipe = new DatePipe('pt-BR');
  dados: { possiRestricao: boolean, data?: Date, placa?: string, destino?: string, cor?: string}[] = [];
  colunasGrid: ColunasListPaginator[] = [
    {
      nameColumn: 'placa',
      nameHeader: 'Placa veículo',
      widthColumn: '50px',
      cellAlign: 'center',
    },
    {
      nameColumn: 'data',
      nameHeader: 'Data',
      widthColumn: '50px',
      cellAlign: 'center',
      valor: (v) => (this.formatarData(v))
    },
    {
      nameColumn: 'destino',
      nameHeader: 'Destino',
      widthColumn: '100px',
      cellAlign: 'center',
    },
    {
      nameHeader: 'Cor',
      nameColumn: 'cor',
      widthColumn: '10%',
      isIcone: true,
      icone: (item) => 'location_on',
      style: (item) =>  item.cor,
      cellAlign: 'center',
      columnTooltipIcone: () => ''
    },
  ];

  lista = [];
  private BARRA_ESPACO = 32;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogPopupRodizioVeiculoComponent>
  ) {
    this.dados = data;
  }

  ngOnInit() {
  }


  fechar() {
    this.dialogRef.close();
  }


  private formatarData(value)  {
  return this.datePipe.transform(value.data, 'dd/MM/yyyy');
  }
}
